<template>
<DashBoardLayout :showNavbar=true :isSearch=false >
    <div class="w100">
        <div class="row">
            <div class="col-xxl-4 col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
                <div class="show-product-wrap product">
                    <div class="col-xl-11 col-lg-11 col-11 product-show-wrap auto sh3 mb-3 position-relative">
                        <div class="c-wrap position-relative p-3 p-summary">
                            <div class="row" v-for="customerDetails in customerDetail" :loading="loading" :key="customerDetails.customer_id">
                                <div class="col-4">
                                    <h2 class="pc-name">{{customerDetails.name}}</h2>
                                    <span class="text-left pt-1">{{customerDetails.mobile}}</span>
                                </div>
                                <div class="col-8"> <span>Total Amount : <b v-if="customerDetails.credit != undefined">{{customerDetails.credit}}</b><b v-else>0</b></span>
                                    <span>Paid Amount : <b v-if="customerDetails.debit != undefined">{{customerDetails.debit}}</b><b v-else>0</b></span>
                                    <span>Payable Amount : <b v-if="customerDetails.balance != undefined">{{customerDetails.balance}}</b><b v-else>0</b></span>
                                </div>
                            </div>
                            <!-- 	<div class="add-to-cart cta-atc-wrap">

<input type="hidden" class="product_id" value="11">

<button class="p-cta-btn">Re-Order</button>

</div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pad-15 col-11 auto col-sm-12">
            <table class="table-wrapper data_table bod">
                <thead>
                    <tr class="heading-tab">
                        <th class="center">Date</th>
                        <th class="center">Due (&#8377;)</th>
                        <th class="center">Paid (&#8377;)</th>
                        <th class="center">Disc (&#8377;)</th>
                        <th class="center">#Order ID</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="paymentmsg != ''">
                        <td colspan="5">No Record Found</td>
                    </tr>
                    <tr v-else v-for="paymentDetail in morePaymentDetail" :loading="loading" :key="paymentDetail.order_id+paymentDetail.cr+paymentDetail.dr">
                        <td class="pl-2">{{paymentDetail.payment_timestamp}}</td>
                        <td class="center">{{paymentDetail.cr}}</td>
                        <td class="center">{{paymentDetail.dr}}</td>
                        <td class="center">{{paymentDetail.discount}}</td>
                        <td class="center">{{paymentDetail.order_id}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</DashBoardLayout>
</template>

<script>
import axios from "axios"
import DashBoardLayout from '../../layouts/DashboardLayout.vue'
import ApiList from '../ApiList'
import globalMixins from '../globalMixins'
export default {
    name: 'Payments',
    mixins: [ApiList, globalMixins],
    // created(){
    //     this.$emit(`update:layout`,DashBoardLayout)
    // },
    components: {
        DashBoardLayout
    },
    data() {
        return {
            loading: false,
            newUrl: "",
            paymentList: [],
            morePaymentDetail: [],
            customerDetail: [],
            customer_id: -1,
            uriParam: '',
            paymentmsg: '',
        }
    },
    mounted() {
        this.checkSession();
        this.loadData()
    },
    methods: {
        loadData() {
            this.customer_id = localStorage.getItem("customer_id")
            this.cart = JSON.parse(localStorage.getItem("cart"));
            console.log(this.cart);
            this.customerDetails();
            this.paymentDetail();

        },
        onPaymentChange(a) {
            this.address_id = a
            this.$emit('onChange', this.address_id)
        },
        customerDetails() {

            this.newUrl = this.apis.apiUrl + this.apis.customerListUrl;
            this.param = {
                params: {
                    token: localStorage.token,
                    customer_id: this.customer_id
                }
            }
            axios.get(this.newUrl, this.param)
                .then((response) => {
                    // console.log(response)
                    // this.orderList = []
                    this.customerDetail = response.data
                    console.log(response.data);
                })
        },
        paymentDetail() {

            this.newUrl = this.apis.apiUrl + this.apis.paymentHistoryUrl
            this.param = {
                params: {
                    token: localStorage.token,
                    customer_id: this.customer_id
                }
            }
            axios.get(this.newUrl, this.param)
                .then((response) => {
                    console.log(response)
                    // this.orderList = []
                    this.morePaymentDetail = response.data;
                    if (response.data.msg != undefined)
                        this.paymentmsg = 'record not found';
                    // console.log(response.data); 
                    // console.log("aa"+this.paymentmsg);
                })
        },
    }
}
</script>
